import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, OperatorFunction, switchMap } from 'rxjs';
import { tap } from 'rxjs/operators';
import { APP_CONFIG, AppConfig } from '@app/app.config';

export interface CsrfResponse {
  headerName: string;
  token: string;
  parametersName: string;
}

@Injectable({
  providedIn: 'root',
})
export class XsrfInterceptor implements HttpInterceptor {
  private readonly baseUrl: string;

  constructor(
    @Inject(APP_CONFIG) config: AppConfig,
    private http: HttpClient,
  ) {
    this.baseUrl = config.apiBaseUrl;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method === 'GET' || req.method === 'HEAD' || req.method === 'OPTIONS')
      return next.handle(req);

    if (req.url.startsWith(this.baseUrl)
      || (this.baseUrl.startsWith('/') && req.url.startsWith(this.baseUrl.slice(1)))
    ) {
      return this.http.get<CsrfResponse>(this.baseUrl + '/security/csrf').pipe(
        switchMap((csrfResponse) => {
          const newReq = req.clone({
            headers: req.headers.set(csrfResponse.headerName, csrfResponse.token),
          });
          return next.handle(newReq);
        }),
      );
    }

    return next.handle(req);
  }

  private updateTokenFromCookie(): OperatorFunction<HttpEvent<any>, HttpEvent<any>> {
    return source => source.pipe(
      tap((resp) => {
        if (!(resp instanceof HttpResponse))
          return;

        // console.log('asdf', (window as unknown as any).cookies.getAll());
        // console.log('response header keys: ', resp.headers.keys());
      }),
    );
  }
}
